import { render, staticRenderFns } from "./PaginationComponent.vue?vue&type=template&id=377e23da&scoped=true&"
import script from "./PaginationComponent.vue?vue&type=script&lang=js&"
export * from "./PaginationComponent.vue?vue&type=script&lang=js&"
import style0 from "./PaginationComponent.vue?vue&type=style&index=0&id=377e23da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377e23da",
  null
  
)

export default component.exports